import type { LayerRaw } from '@tsyl/karonte/lib/types/layers'

import placeholderImg from '@/assets/Burning_Index.png'
import { LAYER_ATTRIBUTIONS } from '@/constants/layers/attributions'
import type { LayerInfo } from '@/types/LayerInfo'

// Shared by the legend and the info popup
const legendItems = [
  {
    text: {
      'en-US': 'Less than 60%',
      'es-ES': 'Menos de 60%',
      'pt-BR': 'Menos de 60%',
      'fr-FR': 'Moins de 60%'
    },
    color: '#4dac26',
    icon: 'mdi-square'
  },
  {
    text: {
      'en-US': '60% to 79%',
      'es-ES': '60% a 79%',
      'pt-BR': '60% a 79%',
      'fr-FR': '60% à 79%'
    },
    color: '#b8e186',
    icon: 'mdi-square'
  },
  {
    text: {
      'en-US': '80% to 89%',
      'es-ES': '80% a 89%',
      'pt-BR': '80% a 89%',
      'fr-FR': '80% à 89%'
    },
    color: '#f7f7f7',
    icon: 'mdi-square'
  },
  {
    text: {
      'en-US': '90% to 96%',
      'es-ES': '90% a 96%',
      'pt-BR': '90% a 96%',
      'fr-FR': '90% à 96%'
    },
    color: '#f1b6da',
    icon: 'mdi-square'
  },
  {
    text: {
      'en-US': '97%+',
      'es-ES': '97%+',
      'pt-BR': '97%+',
      'fr-FR': '97%+'
    },
    color: '#d01c8b',
    icon: 'mdi-square'
  }
]

// Description pending review by Matt Jolly (D2208-482)
const info: LayerInfo = {
  description: {
    'en-US':
      "Daily Burning Index (BI) percentile forecast for North Africa. BI is a relative measure of the potential intensity of a fire; percentiles compare each day's forecast with the historical conditions at the same location.",
    'es-ES':
      'Pronóstico diario del percentil del Índice de Quema (BI) para el norte de África. El BI es una medida relativa de la intensidad potencial de un incendio; los percentiles comparan el pronóstico de cada día con las condiciones históricas en el mismo lugar.',
    'pt-BR':
      'Previsão diária do percentil do Índice de Queima (BI) para o Norte da África. O BI é uma medida relativa da intensidade potencial de um incêndio; os percentis comparam a previsão de cada dia com as condições históricas no mesmo local.',
    'fr-FR':
      "Prévision quotidienne du percentile de l'indice de combustion (BI) pour l'Afrique du Nord. Le BI est une mesure relative de l'intensité potentielle d'un incendie ; les percentiles comparent la prévision de chaque jour aux conditions historiques au même endroit."
  },
  categories: legendItems,
  credit: LAYER_ATTRIBUTIONS.usfsFireLab,
  sourceUrl: 'https://www.wfas.net/'
}

export const burningIndexNorthAfrica: LayerRaw = {
  id: 'BurningIndex',
  type: 'WMS',
  url: '/wfas-proxy/geoserver/wms',
  extraArcgisParameter: { copyright: info.credit },
  title: {
    'en-US': 'Burning Index (BI)',
    'pt-BR': 'Índice de Quema (BI)',
    'es-ES': 'Índice de Quema (BI)',
    'fr-FR': 'Indice de gravure (BI)'
  },
  zindex: 1,
  active: true,
  activeTarget: 'visibility',
  enabled: false,
  opacity: 0.5,
  customProperties: { group: 'riskLayers', img: placeholderImg, info },
  legend: {
    title: 'n/a'
  },
  sublayers: [
    {
      id: 'naf:biperc',
      visible: true,
      legend: {
        title: {
          'en-US': 'Burning Index (BI)',
          'pt-BR': 'Índice de Quema (BI)',
          'es-ES': 'Índice de Quema (BI)',
          'fr-FR': 'Indice de gravure (BI)'
        },
        items: legendItems
      }
    }
  ],
  icon: 'mdi-barley'
}
